import React, { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ChevronRight } from "lucide-react";
import { archiveBundle, duplicateBundle, fetchAdminBundles } from "../api/MerchandisingAPIs";
import { useAuth } from "../utils/auth";
import { isAdmin } from "../utils/roles";

const BundlesAdminPage = () => {
  const navigate = useNavigate();
  const { authState } = useAuth();
  const canEdit = isAdmin(authState.role);
  const queryClient = useQueryClient();
  useEffect(() => {
    if (!canEdit) navigate("/dashboard");
  }, [canEdit, navigate]);
  const { data = [], isLoading, isError } = useQuery({
    queryKey: ["admin-bundles"],
    queryFn: fetchAdminBundles,
    enabled: canEdit,
  });

  if (!canEdit) return null;

  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-8" dir="rtl">
      <div className="mb-6 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <h1 className="text-3xl font-bold text-slate-900">الباقات</h1>
          {canEdit && <button type="button" className="rounded-xl bg-purple-700 px-4 py-2 text-white" onClick={() => navigate("/bundles/new")}>باقة جديدة</button>}
        </div>
        <button
          type="button"
          onClick={() => navigate("/dashboard")}
          className="inline-flex shrink-0 items-center gap-2 rounded-2xl border border-slate-200 bg-white px-8 py-4 text-xl font-bold text-slate-800 shadow-md hover:bg-slate-100"
        >
          <ChevronRight size={28} />
          رجوع
        </button>
      </div>
      {isLoading && <p>جاري التحميل...</p>}
      {isError && <p className="text-red-600">تعذر تحميل الباقات.</p>}
      <div className="space-y-3">
        {data.map((bundle) => (
          <div key={bundle.bundleId} className="rounded-2xl bg-white p-4 shadow-sm">
            <div className="flex items-center justify-between">
              <div>
                <p className="font-bold">{bundle.name}</p>
                <p className="text-sm text-slate-500">{bundle.slug} · {bundle.pricingModel}</p>
              </div>
              <span>{bundle.isArchived ? "مؤرشفة" : bundle.isActive ? "منشورة" : "مسودة"}</span>
            </div>
            {canEdit && (
              <div className="mt-3 flex gap-2">
                <button type="button" className="rounded-lg bg-slate-100 px-3 py-1" onClick={() => navigate(`/bundles/${bundle.bundleId}`)}>تعديل</button>
                <button type="button" className="rounded-lg bg-slate-100 px-3 py-1" onClick={async () => { try { await duplicateBundle(bundle.bundleId); queryClient.invalidateQueries({ queryKey: ["admin-bundles"] }); } catch (error) { toast.error(error.message); } }}>نسخ</button>
                <button type="button" className="rounded-lg bg-red-50 px-3 py-1 text-red-700" onClick={async () => { await archiveBundle(bundle.bundleId); queryClient.invalidateQueries({ queryKey: ["admin-bundles"] }); }}>أرشفة</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BundlesAdminPage;
